module.exports = __webpack_public_path__ + "fa-solid-900.woff2?435a2fea82619f61d3d6ee9dfad2270b";